<template>
  <div>
    <!-- 区分大屏和2.0 -->
    <div v-if="request_prefix === 'bigScreen'">
      <div class="setting-item clearFloat cx_style">
        <div v-if="isDraggable && isAutoLayoutInCol" class="verticallyCenter">
          <span class="fs14 mr16">位置</span>
          <div class="verticallyCenter mr16 flex1">
            <el-input type="number" value="-" style="width: 100%" @focus="getFocus($event)">
              <template slot="suffix">
                <span class="suffix_text">横</span>
              </template>
            </el-input>
          </div>
          <div class="verticallyCenter flex1">
            <el-input type="number" value="-" style="width: 100%" @focus="getFocus($event)">
              <template slot="suffix">
                <span class="suffix_text">纵</span>
              </template>
            </el-input>
          </div>
        </div>
        <div v-if="isDraggable && !isAutoLayoutInCol" class="verticallyCenter">
          <span class="fs14 mr16">位置</span>
          <div class="verticallyCenter mr16 flex1">
            <single-input
              :value.sync="originLeft"
              inputSuffixs="横"
              :max="maxLeft"
              :min="0"
            />
          </div>
          <div class="verticallyCenter flex1">
            <single-input
              :value.sync="originTop"
              inputSuffixs="纵"
              :max="maxTop"
              :min="0"
            />
          </div>
        </div>
        <div class="verticallyCenter mt16" v-if="options.innerElement !== 'cxPagination'">
          <span class="fs14 mr16">尺寸</span>
          <div class="verticallyCenter mr16 flex1">
            <single-input
              class="input-size"
              placeholder="-"
              :value.sync="originWidth"
              :valueType.sync="widthType"
              :showValueType="true"
              :min="1"
            />
          </div>
          <div class="verticallyCenter flex1">
            <single-input
              class="input-size"
              placeholder="-"
              :value.sync="originHeight"
              :valueType.sync="heightType"
              :showValueType="true"
              :min="1"
            />
          </div>
        </div>
      </div>

      <div class="setting-item clearFloat mt16" v-if="isAdmin">
        <div class="content">
          <slider-and-input :value.sync="zIndex" title="层级" titlePosition="allInOneLine" suffix="层" />
        </div>
      </div>
      <div v-if="rotate || !isNaN(rotate)" class="setting-item clearFloat mt16">
        <slider-and-input
          :value.sync="rotate"
          title="旋转"
          titlePosition="allInOneLine"
          :sliderMax="sliderMax"
          suffix="度"
          :min="0"
        />
      </div>
    </div>
    <div v-else>
      <div class="setting-item clearFloat cx_style">
        <div v-if="isDraggable && isAutoLayoutInCol && showPosition" class="verticallyCenter">
          <div class="verticallyCenter mr12 flex1">
            <span class="fs14 mr8">横</span>
            <el-input type="number" value="-" style="width: 100%" @focus="getFocus($event)">
              <template slot="suffix">
                <span class="suffix_text">px</span>
              </template>
            </el-input>
          </div>
          <div class="verticallyCenter flex1">
            <span class="fs14 mr8">纵</span>
            <el-input type="number" value="-" style="width: 100%" @focus="getFocus($event)">
              <template slot="suffix">
                <span class="suffix_text">px</span>
              </template>
            </el-input>
          </div>
        </div>
        <div
          v-if="(isDraggable && !isAutoLayoutInCol && showPosition) || (isPhoneFullScreen && showPosition)"
          class="verticallyCenter"
        >
          <div class="verticallyCenter mr12 flex1">
            <span class="fs14 mr8">横</span>
            <single-input
              v-if="!isShowLeftPerc && !isQuickSite"
              :value.sync="originLeft"
              :max="maxLeft"
              :min="0"
              inputSuffixs="px"
            />
            <single-input
              v-else
              :value.sync="isQuickSite ? '' : originLeft"
              :valueType.sync="leftType"
              :showValueType="true"
              class="input-size"
              placeholder="--"
              :disabled="isQuickSite"
              :max="maxLeft"
              :min="0"
            />
          </div>
          <div class="verticallyCenter flex1">
            <span class="fs14 mr8">纵</span>
            <single-input
              v-if="!isShowLeftPerc && !isQuickSite"
              :value.sync="originTop"
              :max="maxTop"
              :min="0"
              inputSuffixs="px"
            />
            <single-input
              v-else
              class="input-size"
              placeholder="--"
              :disabled="isQuickSite"
              :value.sync="isQuickSite ? '' : originTop"
              :valueType.sync="topType"
              :showValueType="true"
              :max="maxTop"
              :min="0"
            />
          </div>
          <div :class="[isQuickSite ? 'open' : '', 'verticallyCenter quick-set-switch']">
            <el-tooltip
              class="item"
              effect="dark"
              :content="isQuickSite ? '取消定位' : '开启定位'"
              placement="top"
              :open-delay="1000"
            >
              <span class="icon icon-portal-add2" @click="changeQuickSite"></span>
            </el-tooltip>
          </div>
        </div>
        <!--快捷定位-->
        <rect-position-Set
          v-if="isQuickSite && showPosition"
          :left.sync="originLeft"
          :top.sync="originTop"
          :margin.sync="margin"
          :offset.sync="offset"
          :leftType="leftType"
          :topType="topType"
        ></rect-position-Set>
        <div class="verticallyCenter" v-if="showSize">
          <div class="verticallyCenter mr12 flex1">
            <span class="fs14 mr8">宽</span>
            <single-input
              class="input-size"
              placeholder="-"
              :value.sync="originWidth"
              :valueType.sync="widthType"
              :max="showGrid ?  pageLayoutW :maxWidth"
              :inputSuffixs="showGrid?'px':''"
              :min="1"
              :showValueType="showGrid ? false : true"
              :step ="showGrid ? (minGridWidth/2): 1"
              :reduceStep="showGrid ? (minGridWidth + minGridWidth/2) :1"
            />
          </div>
          <div class="verticallyCenter flex1">
            <span class="fs14 mr8">高</span>
            <single-input
              class="input-size"
              placeholder="-"
              :disabled="disAbledHeight"
              :value.sync="disAbledHeight ? '' : originHeight"
              :valueType.sync="heightType"
              :max="showGrid ? 10000 :maxHeight"
              :inputSuffixs="showGrid?'px':''"
              :min="1"
              :showValueType="showGrid ? false : true"
            />
          </div>
        </div>
      </div>

      <div class="setting-item clearFloat" v-if="showIndex">
        <div class="content">
          <slider-and-input :value.sync="zIndex" title="层级" titlePosition="allInOneLine" suffix="层" />
        </div>
      </div>
      <div v-if="(rotate || !isNaN(rotate)) && showRotate" class="setting-item clearFloat">
        <slider-and-input
          :value.sync="rotate"
          title="旋转"
          titlePosition="allInOneLine"
          :sliderMax="sliderMax"
          suffix="度"
          :min="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import silderAndInput from "../../../modules/components/sliderAndInput.vue"
import rectPositionSet from "./rect-position-set"
import {isExist, isInAutoLayout} from "utils"
import { withMethodsHistoryCombine } from "utils/revork"

export default withMethodsHistoryCombine({
  components: { silderAndInput, rectPositionSet },
  props: {
    ids: {
      type: Object
    },
    options: Object,
    mouseType: {
      default: "default",
      type: String
    },
    showSetItem: String,
    disAbledHeight: Boolean,
    isPageLayout: {
      type: Boolean,
      default: false
    },
    showGrid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sliderMax: 360,
      this1: this,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxCode",
        "cxAutoLayout",
        "cxDatePicker",
        "cxInput",
        "cxPagination",
        "cxAnchorComponent",
        "cxIP"
      ],
      maxWidth: null,
      maxHeight: null,
      maxLeft: null,
      maxTop: null,
      // isInAutoLayout: false,
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      pageLayoutId:undefined,
      pageLayoutW:undefined,
      minGridWidth: undefined,
      COLNUM: 48 // 同步栅格划分的份数
    }
  },
  watch: {
    ids: {
      handler: function() {
        this.setInputVal()
        this.getParentNode()
      },
      immediate: true,
      deep: true
    },
    originWidth(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.width = newVal
      }
    },
    originHeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.height = newVal
      }
    },
    originLeft(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.left = newVal
      }
    },
    originTop(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.top = newVal
      }
    },
    width(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setInputMaxMin()
      }
    },
    height(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setInputMaxMin()
      }
    },
    left(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setInputMaxMin()
      }
    },
    top(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setInputMaxMin()
      }
    },
    widthType: {
      handler(){
        // 宽度自动 不在自动布局中时要把宽度还原 否则显示会错乱
        if (this.options.widthType === "自动" && !this.isInAutoLayout && this.showSize) {
          this.$changeOptionsEV("px", "widthType", false)
          this.setBoundSize("width")
        }
      },
      immediate:true
    },
    heightType: {
      handler(){
        if (this.options.heightType === "自动" && !this.isInAutoLayout && this.showSize) {
          this.$changeOptionsEV("px", "heightType", false)
          this.setBoundSize("height")
        }
      },
      immediate:true
    }
  },
  computed: {
    isAutoLayoutInCol() {
      return this.options.isNoConflictCheck
    },
    isQuickSite: {
      get() {
        if (this.options.hasOwnProperty("isQuickSite")) {
          return this.options.isQuickSite
        }
        return false
      },
      set(newVal) {
        if (newVal) {
          // 开启快捷定位之后，定位到第一个
          this.originLeft = 0
          this.originTop = 0
          this.leftType = "%"
          this.topType = "%"
        } else {
          let curRect = document.getElementsByClassName("vdr active")
          let curRectParent = curRect[0]?.parentNode
          if (curRect[0] && curRectParent) {
            // 关闭快捷定位后，将百分比换算为px
            this.leftType = "px"
            this.topType = "px"
            let rectSite = curRect[0].getBoundingClientRect()
            let parentRectSite = curRectParent.getBoundingClientRect()
            this.originLeft = parseInt(rectSite.left - parentRectSite.left)
            this.originTop = parseInt(rectSite.top - parentRectSite.top)
          }
        }
        this.$changeOptionsEV(newVal, "isQuickSite", false)
      }
    },
    zIndex: {
      get() {
        return this.options.zIndex || 0
      },
      set(newVal) {
        let optionName = this.mouseType === "hover" ? "hoverZIndex" : "zIndex"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    isShowLeftPerc() {
      return this.baseComponent.indexOf(this.options.innerElement) > -1 ? true : false
    },
    showQuickPosition() {
      if (this.isShowLeftPerc && (this.leftType === "%" || this.topType === "%")) {
        return true
      }
      return false
    },
    isDraggable() {
      if (this.options && (!this.options.hasOwnProperty("draggable") || this.options.draggable === undefined)) {
        return true
      }
      return this.options.draggable
    },
    grid: {
      get(){
        let rect = document.getElementsByClassName(`container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)[0]
        let grid
        if (!rect) {
          this.getGrid()
          return grid
        }
        let gridContent = rect.closest(".grid-item-content")
        this.pageLayoutId = gridContent.getAttribute("pagelayoutid")
        let gridId = gridContent.getAttribute("data-i")
        const pageIndex =this.pageLayoutId.split("_")[0]
        let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
        let layout = pageLayout.layout.rows[0]
        if (layout.options.waterFlow) {
          grid = layout.options.gridLayout.find(item => item.i === gridId)
          // 画布上有1px 的border
          let pageWidth = this.request_prefix === 'stage' ? 1920 : 414 -2
          if(pageLayout.options.isFullPage){
            this.pageLayoutW = pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3]
          } else if(pageLayout.options.isCustomWidth) {
            pageWidth = pageLayout.options.widthType === "%" ? pageLayout.options.width * pageWidth/100 : pageLayout.options.width
            this.pageLayoutW = pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3]
          } else{
            this.pageLayoutW = this.$store.state[this.request_prefix].page.pageWidth
          }
          // this.pageLayoutW = pageLayout.options.isFullPage ? pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3] : this.$store.state[this.request_prefix].page.pageWidth
          const margin = layout.options.waterFlowMargin ? layout.options.waterFlowMargin[0] : 10
          grid.width = this.computedWidth(grid.w,margin)
        }
        return grid
      },
      set(){

      }
    },
    originWidth: {
      get() {
        if (this.showGrid && this.grid) {
          return this.grid.width
        }
        if (this.isPageLayout && !this.options.width) {
          this.$changeOptionsEV(100, "width", false)
          this.$changeOptionsEV("%", "widthType", false)
          return 100
        }
        return this.fixGetNumber("width")
      },
      set(newVal) {
        if(this.showGrid){
          const pageIndex =this.pageLayoutId.split("_")[0]
          let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
          const margin = pageLayout.layout.rows[0].options.waterFlowMargin ? pageLayout.layout.rows[0].options.waterFlowMargin[0] : 10
          let num  = this.computedWidthNum(newVal,this.pageLayoutW,margin)
          let gridLayout =JSON.parse(JSON.stringify(pageLayout.layout.rows[0].options.gridLayout))
          const gridIndex = gridLayout.findIndex(layout=>layout.i === this.grid.i)
          delete gridLayout[gridIndex].width
          gridLayout[gridIndex].w = num
          this.$emit("updateBefore", { width: num, height: this.originHeight })
          this.$changeOptionsEV(gridLayout, "gridLayout", false, undefined, {
            pageLayoutId: this.pageLayoutId
          },undefined)
          return
        }
        newVal = newVal < 1 ? 1 : newVal
        if (this.request_prefix !== "bigScreen") {
          newVal = newVal > this.maxWidth ? this.maxWidth : newVal
        }
        let optionName = this.mouseType === "hover" ? "hoverWidth" : "width"
        this.$emit("updateBefore", { width: newVal, height: this.originHeight })
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    originHeight: {
      get() {
        if (this.showGrid && this.grid) {
          return this.grid.h
        }
        return this.fixGetNumber("height")
      },
      set(newVal) {
        if(this.showGrid){
          const pageIndex =this.pageLayoutId.split("_")[0]
          let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
          let gridLayout =JSON.parse(JSON.stringify(pageLayout.layout.rows[0].options.gridLayout))
          const gridIndex = gridLayout.findIndex(layout=>layout.i === this.grid.i)
          delete gridLayout[gridIndex].width
          gridLayout[gridIndex].h = newVal
          this.$emit("updateBefore", { width: this.originWidth, height: newVal })
          this.$changeOptionsEV(gridLayout, "gridLayout", false, undefined, {
            pageLayoutId: this.pageLayoutId
          },undefined)
          return
        }
        newVal = newVal < 1 ? 1 : newVal
        if (this.request_prefix !== "bigScreen") {
          newVal = newVal > this.maxHeight ? this.maxHeight : newVal
        }
        let optionName = this.mouseType === "hover" ? "hoverHeight" : "height"
        this.$emit("updateBefore", { width: this.originWidth, height: newVal })
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    margin: {
      get() {
        return this.options.margin
      },
      set(newVal) {
        if (newVal) {
          this.topType = "%"
          this.leftType = "%"
        }
        this.$changeOptionsEV(newVal, "margin", false)
      }
    },
    offset: {
      get() {
        return this.options.offset
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "offset", false)
      }
    },
    originLeft: {
      get() {
        return this.fixGetNumber("left")
      },
      set(newVal) {
        if (this.leftType === "%") {
          newVal = newVal < 0 ? 0 : newVal > 100 ? 100 : newVal
        } else {
          if (this.request_prefix !== "bigScreen") {
            newVal = newVal < 0 ? 0 : newVal
            newVal = newVal > this.maxLeft ? this.maxLeft : newVal
          }
        }
        let optionName = this.mouseType === "hover" ? "hoverLeft" : "left"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    originTop: {
      get() {
        return this.fixGetNumber("top")
      },
      set(newVal) {
        if (this.request_prefix !== "bigScreen") {
          newVal = newVal < 0 ? 0 : newVal
          newVal = newVal > this.maxTop ? this.maxTop : newVal
        }
        let optionName = this.mouseType === "hover" ? "hoverTop" : "top"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    rotate: {
      get() {
        return this.fixGetNumber("rotate")
      },
      set(newVal) {
        let optionName = this.mouseType === "hover" ? "hoverRotate" : "rotate"
        if (newVal == this[optionName]) return
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    leftType: {
      get() {
        return this.options.leftType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "leftType", false)
      }
    },
    topType: {
      get() {
        return this.options.topType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topType", false)
      }
    },
    widthType: {
      get() {
        if(this.showGrid){
          return "px"
        }
        if (this.isPageLayout && !this.options.width) {
          return "%"
        }
        return this.options.widthType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthType", false)
        this.setInputMaxMin()
      }
    },
    heightType: {
      get() {
        if(this.showGrid){
          return "px"
        }
        return this.options.heightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightType", false)
        this.setInputMaxMin()
      }
    },
    showPosition() {
      return this.showSetItem === "position"
    },
    showSize() {
      return this.showSetItem === "size"
    },
    showIndex() {
      return this.showSetItem === "index"
    },
    showRotate() {
      return this.showSetItem === "rotate"
    },
    // 翻页模板
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    isGoTop() {
      return this.options.pluginName?.includes("goTopPlugin") || false
    },
    isInAutoLayout() {
      /* 是否在自动布局中 */
      return isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options) || false
    }
  },
  mounted() {
    // this.colIsAutoLayout = sessionStorage.getItem("colIsAutoLayout")
    /* 是否在自动布局中 */
    // this.isInAutoLayout = isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options)
    this.setInputVal()
  },
  methods: {
    getGrid() {
      setTimeout(()=>{
        let rect = document.getElementsByClassName(`container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)[0]
        let grid
        if (!rect) {
          return grid
        }
        let gridContent = rect.closest(".grid-item-content")
        this.pageLayoutId = gridContent.getAttribute("pagelayoutid")
        let gridId = gridContent.getAttribute("data-i")
        const pageIndex =this.pageLayoutId.split("_")[0]
        let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
        let layout = pageLayout.layout.rows[0]
        if (layout.options.waterFlow) {
          grid = layout.options.gridLayout.find(item => item.i === gridId)
          // 画布上有1px 的border
          let pageWidth = this.request_prefix === 'stage' ? 1920 : 414 -2
          if(pageLayout.options.isFullPage){
            this.pageLayoutW = pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3]
          } else if(pageLayout.options.isCustomWidth) {
            pageWidth = pageLayout.options.widthType === "%" ? pageLayout.options.width * pageWidth/100 : pageLayout.options.width
            this.pageLayoutW = pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3]
          } else{
            this.pageLayoutW = this.$store.state[this.request_prefix].page.pageWidth
          }
          //this.pageLayoutW = pageLayout.options.isFullPage ? pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3] : this.$store.state[this.request_prefix].page.pageWidth
          const margin = layout.options.waterFlowMargin ? layout.options.waterFlowMargin[0] : 10
          grid.width = this.computedWidth(grid.w,margin)
        }
        // return grid
        this.grid = grid
        // return grid
      },500)

    },
    computedWidthNum(curWidth,pageLayoutWidth,margin) {
      // 计算栅格的宽度份数
      const colWidth = (this.pageLayoutW + 2*margin- margin * (this.COLNUM + 1)) / this.COLNUM
      let num = (curWidth +margin) / (colWidth+margin)
      return Math.ceil(num)
    },
    computedWidth(w,margin){
      const colWidth = (this.pageLayoutW + 2*margin - margin * (this.COLNUM + 1)) / this.COLNUM
      this.minGridWidth = colWidth + margin
      return Math.round(colWidth * w + Math.max(0, w - 1) * margin)
    },
    setInputVal() {
      this.left = this.originLeft
      this.top = this.originTop
      this.width = this.originWidth
      this.height = this.originHeight
    },
    getParentNode() {
      if (this.request_prefix === "bigScreen") return
      let nodeClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id
      if (this.ids.uid !== null && typeof this.ids.uid !== "undefined") {
        nodeClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id + "-uid_" + this.ids.uid + "-elementInLayoutId_" + this.ids.elementInLayoutId
      }
      if (this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined") {
        nodeClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id + "-directionIndex_" + this.ids.directionIndex + "-elementInLayoutId_" + this.ids.elementInLayoutId
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        nodeClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id + "-swiperContent_id_" + this.ids.swiperContent_id + "-elementInSwiperId_" + this.ids.elementInSwiperId
      }
      if(this.ids.cellId && isExist(this.ids.elementInDataGridId)){
        nodeClass =  `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-cell_id_${this.ids.cellId}`
      }
      let parentNode = document.getElementsByClassName(nodeClass)[0]?.parentNode
      this.parentW = this.isGoTop ? 600 : parentNode?.offsetWidth
      this.parentH = this.isGoTop ? 600 : parentNode?.offsetHeight
      this.setInputMaxMin()
    },
    // 计算输入框的最大最小值
    setInputMaxMin() {
      if (this.request_prefix === "bigScreen") return
      // 快捷定位之后，最大宽度/高度选择父容器的高度
      if (this.options.isQuickSite) {
        this.maxWidth = this.parentW
        this.maxHeight = this.parentH
        this.maxLeft = 100
        this.maxTop = 100
      } else {
        let currentWidth = this.widthType === "%" ? parseInt((this.width * this.parentW) / 100) : this.width
        let currentHeight = this.heightType === "%" ? parseInt((this.height * this.parentH) / 100) : this.height
        let currentLeft = this.leftType === "%" ? parseInt((this.left * this.parentH) / 100) : this.left
        let currentTop = this.leftType === "%" ? parseInt((this.top * this.parentH) / 100) : this.top
        let offsetLeft = 0
        let offsetTop = 0
        if (this.leftType === "%") {
          offsetLeft = this.options.offset ? this.options.offset[1] + this.options.offset[3] : 0
        }
        if (this.topType === "%") {
          offsetTop = this.options.offset ? this.options.offset[0] + this.options.offset[2] : 0
        }
        this.maxWidth = this.widthType === "%" ? 100 : Math.floor(this.parentW - currentLeft - offsetLeft)
        this.maxWidth === 0 ? this.maxWidth = currentWidth : ""
        this.maxHeight = this.heightType === "%" ? 100 : Math.floor(this.parentH - currentTop - offsetTop)
        this.maxHeight === 0 ? this.maxHeight = currentHeight : ""
        this.maxLeft = this.leftType === "%" ? 100 : Math.floor(this.parentW - currentWidth)
        this.maxTop = this.topType === "%" ? 100 : Math.floor(this.parentH - currentHeight)
      }
    },
    // 切换快捷定位的开关
    changeQuickSite() {
      if(this.isGoTop && this.isQuickSite) {
        return
      }
      this.isQuickSite = !this.isQuickSite
      this.margin = 0
      this.offset = 0
      this.setInputMaxMin()
    },
    fixGetNumber(name) {
      const num =
        this.mouseType === "hover" ? this.options["hover" + name[1].toUpperCase() + name.slice(1)] : this.options[name]
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      } else return num
    },
    fixSetNumber(num) {
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      }
      return num
    },
    leftTypeHandleCommand(val) {
      if (this.leftType === val) {
        return
      }
      this.leftType = val
      this.left = 0
      this.margin = null
      this.offset = null
    },
    topTypeHandleCommand(val) {
      if (this.topType === val) {
        return
      }
      this.topType = val
      this.top = 0
      this.margin = null
      this.offset = null
    },
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      this.width = val === "%" ? 100 : 200
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      this.height = val === "%" ? 100 : 200
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    changeValue() {
      if (this.margin) {
        this.margin = null
      }
    },
    setValue(originName, name) {
      if (this[name]) {
        this[originName] = this[name]
      } else {
        // 不允许输入为空 为空的情况恢复原来的值
        this[name] = this[originName]
      }
    },
    // 获取元素的真实尺寸
    setBoundSize(type) {
      let rect, className
      if (isExist(this.options.elementInLayoutId)) {
        className = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.ids.uid}-elementInLayoutId_${this.ids.elementInLayoutId}`
      } else if (isExist(this.ids.rect_id)) {
        className = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`
      }
      let element = className ? document.getElementsByClassName(className)[0] : ""
      rect = element ? element.getBoundingClientRect() : ""
      if (rect) {
        let boundWidth = rect.width
        let boundHeight = rect.height
        if (type === "width" && parseInt(boundWidth) !== this.width) this.$changeOptionsEV(parseInt(boundWidth), "width", false)
        if (type === "height"&& parseInt(boundHeight) !== this.height) this.$changeOptionsEV(parseInt(boundHeight), "height", false)
      }
    },
  }
})
</script>

<style scoped>
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

.color000 {
  color: var(--text);
}

::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
}

.quick-set-switch {
  width: 32px;
  height: 32px;
  text-align: center;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f3f3f3;
  color: var(--iconColor);
  cursor: pointer;
}

.quick-set-switch .item {
  display: inline-block;
  width: 100%;
  line-height: 26px;
  border-radius: 4px;
}

.quick-set-switch.open .item {
  color: var(--themeColor);
  background-color: #fff;
  border: 2px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}

.quick-set-switch:hover {
  color: #000;
}
</style>
